import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { workflowAPI } from '../../utils/crmApi';

const WorkflowDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [workflow, setWorkflow] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                setLoading(true);
                const res = await workflowAPI.getById(id);
                if (res.data?.success) {
                    setWorkflow(res.data.data);
                } else {
                    setError(res.data?.message || 'Failed to load workflow');
                }
            } catch (e) {
                setError(e.response?.data?.message || 'Failed to load workflow');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id]);

    if (loading) {
        return (
            <div className="p-6">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-6 text-red-600 text-sm">{error}</div>
        );
    }

    if (!workflow) {
        return (
            <div className="p-6 text-sm">Workflow not found.</div>
        );
    }

    return (
        <div className="p-6 space-y-4">
            <div className="flex items-center justify-between">
                <h1 className="text-xl font-semibold text-foreground">{workflow.name}</h1>
                <div className="flex items-center gap-2">
                    <Link to={`/workflows/${workflow._id}/edit`} className="px-3 py-1.5 text-sm text-white rounded" style={{ backgroundColor: '#2563eb' }}>
                        Edit
                    </Link>
                    <button onClick={() => navigate(-1)} className="px-3 py-1.5 text-sm border rounded">Back</button>
                </div>
            </div>

            <div className="bg-card rounded-lg border p-4">
                <div className="text-sm text-foreground">{workflow.description || 'No description'}</div>
                <div className="mt-3 grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                    <div>
                        <div className="text-muted-foreground">Category</div>
                        <div className="font-medium">{workflow.category || '—'}</div>
                    </div>
                    <div>
                        <div className="text-muted-foreground">Status</div>
                        <div className="font-medium">{workflow.status || 'draft'}</div>
                    </div>
                    <div>
                        <div className="text-muted-foreground">Created</div>
                        <div className="font-medium">{workflow.createdAt ? new Date(workflow.createdAt).toLocaleString() : '—'}</div>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-card rounded-lg border p-4">
                    <div className="font-semibold mb-2">Trigger</div>
                    <pre className="text-xs bg-muted p-3 rounded overflow-auto">{JSON.stringify(workflow.trigger, null, 2)}</pre>
                </div>
                <div className="bg-card rounded-lg border p-4">
                    <div className="font-semibold mb-2">Actions</div>
                    <pre className="text-xs bg-muted p-3 rounded overflow-auto">{JSON.stringify(workflow.actions, null, 2)}</pre>
                </div>
            </div>
        </div>
    );
};

export default WorkflowDetail;


